// resources/js/core/logger.ts
import type { Logger } from "@/types/global";

export function createLogger(env: "development" | "production"): Logger {
    const prefix = "[easti]";
    const noop = () => { };
    if (env === "production") {
        // keep minimal logging in prod
        return {
            info: noop,
            warn: (m, meta) => console.warn(prefix, m, meta ?? ""),
            error: (m, meta) => console.error(prefix, m, meta ?? ""),
        };
    }
    return {
        info: (m, meta) => console.info(prefix, m, meta ?? ""),
        warn: (m, meta) => console.warn(prefix, m, meta ?? ""),
        error: (m, meta) => console.error(prefix, m, meta ?? ""),
    };
}
